class InsuranceCto extends HTMLElement {
  insuranceUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.insuranceUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.insuranceUpdate, this.insuranceResetHandler.bind(this));
    this.initCTOModal();
  }

  disconnectedCallback() {
    if (this.insuranceUpdateUnsubscriber) {
      this.insuranceUpdateUnsubscriber();
    }
  }

  initCTOModal() {
    const insuranceCTOContainer = this.querySelector(".container-box-2");
    insuranceCTOContainer.addEventListener("click", (event) => {
      const targetId = this.dataset.modalTarget;
      const internalStatus = insuranceCTOContainer.classList.contains("internal");
      if (targetId && !internalStatus) {
        const modalTrigger = document.querySelector(`.ac-modal-trigger[data-modal-target="${targetId}"]`);
        if (modalTrigger) {
          modalTrigger.click();
        }
      }
    });
  }

  insuranceResetHandler(callback) {
    const { reset } = callback;

    if (reset) {
      const insuranceLabel = this.querySelector("label");
      const insuranceInput = this.querySelector(".add-on-insurance-checkbox");

      insuranceLabel.classList.remove("checked");
      insuranceInput.checked = false;
    }
  }
}

customElements.define("insurance-cto", InsuranceCto);
